//Put your own Smart contracts revert codes
module.exports.REVERT_CODES = {
	"ONLY_WALLET": "E00",
	"OWNER_ALREADY_EXISTS": "E01",
	"NO_OWNER": "E02",
	"NO_TX": "E03",
	"NOT_CONFIRMED": "E04",
	"ALREADY_CONFIRMED": "E05",
	"ALREADY_EXEC": "E06",
	"IS_NULL": "E07",
	"REQ_INVALID": "E08",
	"NOT_FULLY_CONFIRMED": "E10",
};
